document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.mgm-product-details__accordion-header');
  
  accordions.forEach(function(accordion) {
    accordion.addEventListener('click', function() {
      const parent = this.parentElement;
      const content = this.nextElementSibling;
      
      // Toggle active class
      parent.classList.toggle('active');
      
      // Toggle height
      if (parent.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
      
      // Rotate icon
      const icon = this.querySelector('.mgm-product-details__accordion-icon');
      if (parent.classList.contains('active')) {
        icon.style.transform = 'rotate(180deg)';
      } else {
        icon.style.transform = 'rotate(0)';
      }
    });
  });
}); 